import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import { sortOptions } from "../config"
import RadioButton from "./elements/RadioButton"
import { useProductFilters } from "@nosto/preact"

function ToggleSidebarButton({ className }) {
    return (
        <label
            className={`ns-act-btn ns-close-sidebar ns-absolute ns-d-block ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ${className}`}
            for="toggle-mobile-sidebar"
            data-close-filters
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar({ toggleId }) {
    const { loading, facets } = useFacets()
    const { activeSort, setSort } = useSort(sortOptions)
    const { removeAll } = useProductFilters()
    let clearBtnActiveClass = "";

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    useEffect(() => {
        // close filters
        let closeBtns = document.querySelectorAll(".ns-serp .ns-icon-close, .ns-serp .ns-sidebar-backdrop, .ns-serp .ns-sidebar-dropdown .apply-filters");
        closeBtns.forEach(function(elem) {
            elem.addEventListener("click", function(e) {
                document.querySelector("body").classList.remove("scroll-lock");
                e.currentTarget.closest(".ns-serp").querySelector(".ns-sidebar-wrapper").classList.remove("opened");
                e.currentTarget.closest(".ns-serp").querySelector(".ns-sidebar-backdrop").classList.add("ns-d-none");
            });
        });

        // open/close Sort options
        document.querySelector(".ns-serp .ns-sidebar-dropdown.custom-actions").addEventListener("click", function(e) {
            e.currentTarget.classList.toggle("ns-active");
        })
    }, [facets?.length > 0])

    // open filters
    document.querySelector(".ns-serp [data-open-filters]").addEventListener("click", function(e) {
        document.querySelector("body").classList.add("scroll-lock");
        e.currentTarget.closest(".ns-serp").querySelector(".ns-sidebar-wrapper").classList.add("opened");
        e.currentTarget.closest(".ns-serp").querySelector(".ns-sidebar-backdrop").classList.remove("ns-d-none");
    })

    return(
        <>
            {facets?.length > 0 ? (
                <>
                    <input type="checkbox" id={toggleId} class="ns-facet-sidebar-toggle ns-d-none" />
                    <label
                        class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                        for="toggle-mobile-sidebar"
                    />
                    <div
                        class="ns-sidebar-wrapper ns-d-none ns-d-md-block ns-h-100 ns-col-3 ns-col-l-2"
                        style={loading ? "opacity: 0.3;" : ""}
                    >
                        <div class="ns-sidebar-content ns-relative ns-background-white ns-mr-0 ns-mr-md-auto">
                            <div class="ns-sidebar-header ns-d-flex ns-align-items-baseline heading-5 filters-inner--heading">
                                <span class="ns-color-black">Filters & Sort</span>
                                <ToggleSidebarButton />
                            </div>
                            <div class="ns-sidebar-menu">
                                <ul class="ns-list-unstyled ns-m-0 filters-inner--filters">
                                    <li class="ns-sidebar-dropdown ns-active custom-actions">
                                        <a class="ns-d-inline-block ns-relative ns-w-100 ns-border-box ns-text-undecorated filter-headers" href="javascript:void(0)" data-nosto-element="sort">
                                            <span class="ns-color-black ns-font-4 filter-heading">SORT</span><i class="ns-icon ns-icon-plusminus ns-absolute"></i>
                                        </a>
                                        <div class="ns-sidebar-submenu ns-d-none ns-py-4">
                                            <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                                                {options?.map((value, idx) => (
                                                    <li>
                                                        <RadioButton
                                                            value={value.value}
                                                            selected={value.value == activeSort}
                                                            onChange={e => handleSortChange(e)}
                                                            className="ns-checkbox"
                                                            name="sortBy"
                                                            label={value.label}
                                                        />
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </li>
                                    {facets?.map(facet => {
                                        switch (facet.type) {
                                            case "terms":
                                                facet.data?.map(inner => {
                                                    if(inner.selected) { clearBtnActiveClass = "active" }
                                                })
                                                return <Facet facet={facet} />
                                            case "stats":
                                                facet.data?.map(inner => {
                                                    if(inner.selected) { clearBtnActiveClass = "active" }
                                                })
                                                return <RangeFacet facet={facet} />
                                            default:
                                                return null
                                        }
                                    })}
                                </ul>
                            </div>
                        </div>
                        <div class="ns-sidebar-dropdown ns-active ns-sidebar-actions ns-background-white">
                            <ul class="ns-list-unstyled ns-p-0 ns-m-0">
                                <li class="ns-m-0" onClick={() => { removeAll() }}>
                                    <button class={`clear-filters ${clearBtnActiveClass}`}>Clear All</button>
                                </li>
                                <li class="ns-m-0">
                                    <button class="apply-filters">Apply</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </>
            ) : (
                ""
            )}
        </>
    )
}